export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEFTldQLUhhDCEiAb1PAADATAAAwFIFAMBQAADATw8CvVMCBL1WAADAWQAAwFQAAMBXAADAVgARvVtBGCFrwE0ABgASgUAbg3KFQQEAAQABAAEAGQAfAAEAAQAGAIEyAAEAAQABAAEAGQAfAAEAAQAGAGEMJXUBvgKPSQ++BBABvhSDPwC9UAABvWcAAL1PAgS9eAACvX4AAL19AAC9Uy0AwFAAAMBP", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/NWP-V.bcmap
// module id = 682
// module chunks = 502